<template>
  <div class="container-msg" :class="{ 'ia-class': type === 'ia', 'user-class': type === 'user' }">
    <img v-if="type === 'ia'" class="icon-chat" :src="require('@/assets/svgs/icon_chat.svg')" alt="Icono" />
    <p :class="{ 'txt-msg-user': type === 'user', 'txt-msg-ia': type === 'ia' }" v-html="formatMsg(msg)"></p>
    <img v-if="type === 'user'" class="icon-chat" :src="require('@/assets/svgs/icon_user.svg')" alt="Icono" />
  </div>
</template>

<script>
export default {
  name: 'IAMsg',
  props: {
    msg: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },

  methods: {
    formatMsg (text) {
      if (!text) return ''

      let html = text

      // Escapar HTML para evitar que la respuesta de la IA
      // pueda insertar etiquetas directamente
      html = html
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')

      // Negritas: **texto**
      html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')

      // Cursivas: *texto*
      html = html.replace(/\*(.*?)\*/g, '<em>$1</em>')

      // Código inline: `texto`
      html = html.replace(/`([^`]+)`/g, '<code>$1</code>')

      // URLs
      html = html.replace(
        /(https?:\/\/[^\s<]+)/g,
        '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
      )

      // Saltos de línea
      html = html.replace(/\n/g, '<br>')

      return html
    }
  }

}
</script>

<style scoped>
.container-msg {
  margin: 5px;
  display: flex;
  color: white;
  align-items: center;
}

.ia-class {
  flex-direction: row;
}

.user-class {
  flex-direction: row-reverse;
}

.txt-msg-user {
  background: #2b8be2;
  color: #ffffff;
  padding: 10px;
  margin-right: 5px;
  border-radius: 8px;
  text-align: right;
}

.txt-msg-ia {
  background: #faf9e7;
  color: #0d0d0d;
  padding: 10px;
  margin-right: 5px;
  border-radius: 8px;
  text-align: left;
}

.icon-chat {
  width: 30px;
  height: 30px;
  margin-right: 20px;
  background-color: white;
  border-radius: 50%;
  text-align: left;
}
</style>
